import React from 'react';
import { TOTAL_SECONDS } from '../data/teaser';
interface CountdownRingProps {
  remaining: number;
  variant?: 'hero' | 'pill';
  stopped?: boolean;
  paused?: boolean;
}
export function CountdownRing({
  remaining,
  variant = 'pill',
  stopped = false,
  paused = false
}: CountdownRingProps) {
  const clamped = Math.max(0, Math.min(TOTAL_SECONDS, remaining));
  const seconds = Math.ceil(clamped - 0.0001) < 0 ? 0 : Math.ceil(clamped - 0.0001);
  const progress = clamped / TOTAL_SECONDS;
  const done = clamped <= 0 || stopped;
  if (variant === 'hero') {
    const radius = 46;
    const circumference = 2 * Math.PI * radius;
    return <div className="relative h-44 w-44" role="timer" aria-label={`${seconds} seconds`} data-id="element-37" data-mp="2b6s9ayxvgl7i">
        <div className="absolute inset-2 rounded-full bg-solventum-primary/10" data-id="element-38" data-mp="2g0cz43pba8vm" />
        <svg className="absolute inset-0 h-full w-full -rotate-90" viewBox="0 0 100 100" data-id="element-39" data-mp="1iicykolrwp1z">
          <circle cx="50" cy="50" r={radius} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="2" data-id="element-40" data-mp="1nhphwzdfrdzt" />
          <circle cx="50" cy="50" r={radius} fill="none" stroke="#05dd4d" strokeWidth="2" strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={circumference * (1 - progress)} className="transition-[stroke-dashoffset] duration-100 ease-linear" data-id="element-41" data-mp="22t5tlctd7m91" />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center font-headline text-7xl font-extrabold tabular-nums text-solventum-primary" data-id="element-42" data-mp="1k2y2xu6uqo9q">
          {seconds}
        </span>
      </div>;
  }
  const radius = 16;
  const circumference = 2 * Math.PI * radius;
  return <div className="flex items-center gap-2.5 rounded-full border border-white/10 bg-white/5 px-4 py-2 backdrop-blur-sm" role="timer" aria-label={`${seconds} seconds left`} data-id="element-43" data-mp="39hvzh2dt3j5j">
      <div className="relative h-9 w-9 flex-shrink-0" data-id="element-44" data-mp="12u58con5ujmn">
        <svg className="h-9 w-9 -rotate-90" viewBox="0 0 36 36" data-id="element-45" data-mp="12skhpa3yvku2">
          <circle cx="18" cy="18" r={radius} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="2.5" data-id="element-46" data-mp="17lnc1kgkiybb" />
          <circle cx="18" cy="18" r={radius} fill="none" stroke={paused && !done ? 'rgba(5,221,77,0.45)' : '#05dd4d'} strokeWidth="2.5" strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={circumference * (1 - progress)} className="transition-[stroke-dashoffset] duration-100 ease-linear" data-id="element-47" data-mp="xu0u759q60zl" />
        </svg>
        <span className={`absolute inset-0 flex items-center justify-center font-headline text-xs font-bold tabular-nums ${done ? 'text-solventum-primary' : 'text-white'}`} data-id="element-48" data-mp="1gnd2amyprr7i">
          {seconds}
        </span>
      </div>
      <span className="font-body text-xs leading-tight text-white/80" data-id="element-49" data-mp="3tqovrn77fe9x">
        {done ? '0 seconds left' : paused ? 'paused' : 'seconds left'}
      </span>
    </div>;
}